import React from 'react';
import ArticlesComponent from '../../../components/articles';
const Articles = () => (
  <ArticlesComponent/>
)

export default Articles;
